import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 保存类型
 */
class SaveType extends UltMeta {
    SAVE_TO_DRAFT = new Meta(1, "保存为草稿");
    SAVE_AND_COMMIT = new Meta(2, "保存并提交");
}

export const SAVE_TYPE = new SaveType();

/**
 * 进销存 入库管理状态
 */
class State extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    TO_BE_INBOUND = new Meta(2, "待入库");
    INBOUNDED = new Meta(4, "已入库");
    REJECTED = new Meta(3, "已驳回");
    INBOUND_INVALID = new Meta(5, "已作废");
}

export const STATE = new State();

/**
 * 入库类型
 */
class InboundType extends UltMeta {
    PURCHASE_INBOUND = new Meta(1, "采购入库");
    REFUND_NECK_INBOUND = new Meta(2, "退领入库");
    ALLOT_INBOUND = new Meta(3, "调拨入库");
    INVENTORY_PROFIT_INBOUND = new Meta(4, "盘盈入库");
    SALES_RETURNS_INBOUND = new Meta(5, "销售退货入库");
    PLEDGE_INBOUND = new Meta(16, "质押入库");
    OTHER_INBOUND = new Meta(6, "其他入库");
}

export const INBOUND_TYPE = new InboundType();
